var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Lo sentimos, ocurrió un error")]),_c('p',[_vm._v("Estaremos de vuelta lo más pronto posible")]),_c('hr')])
}]

export { render, staticRenderFns }